import React, { useState } from 'react'
import { Tabs } from 'antd'
import { dischargeInstructionsMockData } from './utils/mockdata'
import useDischargeFilters from './hooks/useDischargeFilters'
import useDischargeModals from './hooks/useDischargeModals'
import DischargeHeader from './Components/DischargeHeader'
import DischargeFilters from './Components/DischargeFilters'
import DischargeTable from './Components/DischargeTable'
import DischargeCardList from './Components/DischargeCardList'
import DischargeDetailView from './Components/DischargeDetailView'
import DischargeModal from './Components/DischargeModal'

const { TabPane } = Tabs

const DischargeInstructions = () => {
  const [activeTab, setActiveTab] = useState('table')

  // Use custom hooks
  const {
    filterValues,
    filteredData,
    completedDischarges,
    pendingDischarges,
    searchText,
    setSearchText,
    departmentFilter,
    setDepartmentFilter,
    statusFilter,
    setStatusFilter,
    dateRange,
    setDateRange
  } = useDischargeFilters(dischargeInstructionsMockData)

  const { isModalVisible, viewDischarge, form, showModal, handleCancel, handleCreate, handleView, handleCloseView } =
    useDischargeModals()

  // Combine all filter state for passing to components
  const filterState = {
    searchText,
    setSearchText,
    departmentFilter,
    setDepartmentFilter,
    statusFilter,
    setStatusFilter,
    dateRange,
    setDateRange
  }

  // Handle viewing a discharge instruction detail
  const onViewDischarge = (discharge) => {
    handleView(discharge)
    setActiveTab('view')
  }

  // Handle closing the detail view
  const onCloseDetailView = () => {
    handleCloseView()
    setActiveTab('table')
  }

  // If viewing a discharge instruction detail
  if (viewDischarge) {
    return <DischargeDetailView discharge={viewDischarge} onClose={onCloseDetailView} />
  }

  return (
    <div style={{ padding: '24px' }}>
      {/* Header */}
      <DischargeHeader onCreateNew={showModal} />

      {/* Filters */}
      <DischargeFilters filterValues={filterValues} filterState={filterState} />

      {/* Tabs for different views */}
      <Tabs activeKey={activeTab} onChange={setActiveTab}>
        <TabPane tab='Table View' key='table'>
          <DischargeTable data={filteredData} onView={onViewDischarge} />
        </TabPane>

        <TabPane tab={`Pending (${pendingDischarges.length})`} key='pending'>
          <DischargeCardList discharges={pendingDischarges} onView={onViewDischarge} />
        </TabPane>

        <TabPane tab={`Completed (${completedDischarges.length})`} key='completed'>
          <DischargeTable data={completedDischarges} onView={onViewDischarge} />
        </TabPane>

        <TabPane tab='View Instructions' key='view' disabled={!viewDischarge}>
          {/* Content is rendered conditionally at the top level */}
        </TabPane>
      </Tabs>

      {/* Create New Instructions Modal */}
      <DischargeModal
        isVisible={isModalVisible}
        onCancel={handleCancel}
        onSubmit={handleCreate}
        form={form}
        filterValues={filterValues}
      />
    </div>
  )
}

export default DischargeInstructions
